import React, { useRef, useState } from "react";
import { endpoints } from "../../hooks/endpoints";
import OTPInput from "../OTPinput/OTPinput";
import OTPtimer from "./OTPtimer";
import { TutorFormDataI } from "./TutorRegistration";

const OTPverification = ({
  formData,
  handleNext,
  handlePrev,
  setFormData,
}: {
  formData: TutorFormDataI;
  handleNext: () => void;
  handlePrev: () => void;
  setFormData: React.Dispatch<React.SetStateAction<TutorFormDataI>>;
}) => {
  const length = 4;
  const timerIntervalRef = useRef<NodeJS.Timeout>(null);
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    try {
      setIsPending(true);
      setError("");
      const response = await fetch(endpoints.verifyOTP, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          otp: otp.join(""),
          email: formData.email,
        }),
      });

      const res = await response.json();

      if (!response.ok) {
        throw Error(res.data);
      }
      setFormData((prev) => ({ ...prev, otp: otp.join("") }));
      handleNext();
    } catch (e) {
      console.error();
      setError(e.message);
    } finally {
      setIsPending(false);
    }
  };

  return (
    <form onSubmit={handleVerifyOTP} className="space-y-4">
      <h4 className="mx-auto mb-4 pb-1 text-xl font-semibold border-b-2 border-(--primary-color-light) w-fit">
        أدخل رمز الOTP
      </h4>

      <p className="text-center">
        تم إرسال رمز OTP مكون من أربع أرقام إلى الإيميل الذي كتبته.
      </p>
      <p className="text-center">يرجى إدخال الأربع أرقام بالترتيب من الشمال.</p>
      <p className="text-center text-red-600">
        إذا لم يصلك رمز OTP ، يرجى النظر في صندوق الSpam.
      </p>

      <OTPInput
        length={length}
        otp={otp}
        setOtp={setOtp}
        isPending={isPending}
      />

      <OTPtimer
        timerIntervalRef={timerIntervalRef}
        formData={formData}
        setError={setError}
        setMsg={setMsg}
      />

      <div className="flex justify-center gap-3 mt-4">
        <button
          type="button"
          onClick={handlePrev}
          disabled={isPending}
          className="px-4 py-2 rounded-md bg-gray-300 text-gray-800 hover:bg-gray-400 transition disabled:opacity-50"
        >
          رجوع
        </button>

        <button
          type="submit"
          onClick={handleVerifyOTP}
          disabled={isPending}
          className="px-4 py-2 rounded-md bg-(--primary-color) text-white hover:bg-(--primary-color-dark) transition disabled:opacity-50"
        >
          {isPending ? "التالي ..." : "التالي"}
        </button>
      </div>

      {!!msg && (
        <div className="mt-4 w-full text-center bg-yellow-50 text-yellow-700 border border-yellow-500 py-2 px-4 rounded-md">
          {msg}
        </div>
      )}

      {!!error && (
        <div className="mt-4 w-full text-center bg-red-50 text-red-500 border border-red-400 py-2 px-4 rounded-md">
          {error}
        </div>
      )}
    </form>
  );

  // return (
  //   <form onSubmit={handleVerifyOTP}>
  //     <h4
  //       className="p-2 mb-4 mx-auto"
  //       style={{
  //         width: "fit-content",
  //         borderBottom: "2px solid #673de6",
  //       }}
  //     >
  //       أدخل رمز الOTP
  //     </h4>
  //     <p className="text-center">
  //       تم إرسال رمز OTP مكون من أربع أرقام إلى الإيميل الذي كتبته.
  //     </p>
  //     <p className="text-center">يرجى إدخال الأربع أرقام بالترتيب من الشمال.</p>
  //     <p className="text-center text-danger">
  //       إذا لم يصلك رمز OTP ، يرجى النظر في صندوق الSpam.
  //     </p>
  //     <OTPInput
  //       length={length}
  //       otp={otp}
  //       setOtp={setOtp}
  //       isPending={isPending}
  //     />
  //     <OTPtimer
  //       timerIntervalRef={timerIntervalRef}
  //       formData={formData}
  //       setError={setError}
  //     />
  //     <button
  //       type="button"
  //       className="btn btn-secondary rounded-ea me-2"
  //       onClick={handlePrev}
  //       disabled={isPending}
  //     >
  //       رجوع
  //     </button>
  //     <button
  //       type="submit"
  //       className="rounded-ea"
  //       onClick={handleVerifyOTP}
  //       disabled={isPending}
  //     >
  //       {isPending ? "التالي ..." : "التالي"}
  //     </button>

  //     {!!error && (
  //       <div
  //         className="alert alert-danger rounded-ea w-100 mt-3 text-center"
  //         role="alert"
  //       >
  //         {error}
  //       </div>
  //     )}
  //   </form>
  // );
};

export default OTPverification;
